import * as customerPortal from '@jazel/customer-portal';
export * as customerPortal from '@jazel/customer-portal';

export function start() {
    return customerPortal.start();
}
